/* eslint-disable jsx-a11y/alt-text */
import React, { useState } from 'react';
import { string } from 'prop-types';
import { useHistory } from 'react-router-dom';
import { createUseStyles, useTheme } from 'react-jss';
import SLUGS from 'resources/slugs';
import DropdownComponent from 'components/dropdown';
import { removeUserSession, getNombre, getImagenPerfil } from 'views/Utils/Common';
import { fetchConToken } from 'helpers/fetch';
import { getDataSession, setDataSession } from 'views/Utils/Common';
import { Link } from 'react-router-dom';
import { useLocation } from "react-router-dom";
import Notificacion from 'components/alert/Notificacion';
import { useGlobalState } from 'resources/GlobalStateContext';
import TituloPagina from 'components/header/TituloPagina';
import { HubConnectionBuilder, HttpTransportType } from '@microsoft/signalr';
import Swal from 'sweetalert2';

// IMAGES
import campana from 'images/panel/menu/menu_blanco/icon_mensajes.svg';
import carrito from 'images/panel/menu/menu_blanco/icon_compras.svg';
import avatar from 'images/panel/topbar/avatar.png';
import Ayuda from 'images/panel/menu/menu_blanco/icon_soporte.svg';

// Lenguajes
import { LanguageSelector } from "components/lenguages/LanguageSelector";

const useStyles = createUseStyles((theme) => ({
    headerWrapper: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        position: 'sticky',
        top: 0,
        zIndex: 2,
        width: '100%',
        boxSizing: 'border-box',
        padding: '0 1rem',
        '@media (max-width: 768px)': {
            padding: '0 0.5rem'
        }
    },
    titleContainer: {
        display: 'flex',
        alignItems: 'center',
        minWidth: 0,
        '@media (max-width: 768px)': {
            marginLeft: 36,
            maxWidth: '50%',
            overflow: 'hidden'
        }
    },
    actionsContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        flexShrink: 0
    },
    avatar: {
        height: 35,
        width: 35,
        minWidth: 35,
        borderRadius: 50,
        marginLeft: 14,
        border: `1px solid ${theme.color?.lightGrayishBlue2 || '#fff'}`,
        '@media (max-width: 768px)': {
            marginLeft: 8
        }
    },
    userInfoDesktop: {
        display: 'grid',
        gridTemplateRows: 'repeat(2,max-content)',
        alignSelf: 'center',
        '@media (max-width: 768px)': {
            display: 'none !important'
        }
    },
    iconStyles: {
        cursor: 'pointer',
        marginLeft: 25,
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        '@media (max-width: 768px)': {
            marginLeft: 10
        },
        zIndex: 10
    },
    badgeStyle: {
        position: 'absolute',
        top: -6,
        right: -6,
        color: 'red',
        fontSize: '11px',
        fontWeight: 'bold',
        textAlign: 'center'
    }
}));

function HeaderComponent() {
    let location = useLocation();
    const { push } = useHistory();
    const theme = useTheme();
    const classes = useStyles({ theme });
    const [totalxPagina] = useState(5);
    const [, setLogo] = useState(avatar);
    const baseUrl = process.env.REACT_APP_API_URL;
    const [connection, setConnection] = useState(null);
    let [notificaciones, setNotificaciones] = useState(0);
    const { setGlobalVariable } = useGlobalState();
    const { globalTitulo } = useGlobalState();
    let [, setTimbresEmpresa] = useState([]);

    React.useEffect(() => {
        const connect = new HubConnectionBuilder().withUrl(baseUrl + "/notificacion", {
            skipNegotiation: true,
            transport: HttpTransportType.WebSockets
        }).withAutomaticReconnect().build();
        setConnection(connect);
    }, [baseUrl]);

    React.useEffect(() => {
        if (connection) connection.start().then(async () => {
            await connection.invoke("Add", getDataSession('empresa') + "-" + getDataSession('sucursal'));
            connection.on("ReceiveNotificacionMensajes", function (message) {
                const parsedMessage = parseInt(message, 10);
                const safeMessage = isNaN(parsedMessage) ? 0 : parsedMessage;

                if (safeMessage === 0) {
                    setDataSession("notificaciones", 0);
                    setNotificaciones(0);
                } else {
                    const rawStored = getDataSession("notificaciones");
                    const parsedStored = parseInt(rawStored, 10);
                    const safeStored = isNaN(parsedStored) ? 0 : parsedStored;

                    const total = safeMessage + safeStored;
                    setDataSession("notificaciones", total);
                    setNotificaciones(total);
                }
            });
        }).catch((error) => console.log(error));
    }, [connection]);

    React.useEffect(() => {
        function getTimbresEmpresa() {
            if (getDataSession('rol') !== "ADMINISTRADOR") fetchConToken(`TimbresEmpresas`).then(response => setTimbresEmpresa(response));
        }

        async function getLogo(page) {
            if (getDataSession('rol') !== "ADMINISTRADOR") {
                const response = await fetchConToken(`ConfiguracionesEmpresas/GetList?paginas=${page}&totalXPagina=${totalxPagina}&busqueda=Logo`);
                setLogo((response != null && response.length > 0 && response[0]?.valor != null) ? response[0]?.valor : avatar);
            }
        }

        async function getSucursales() {
            const responseSucursal = await fetchConToken(`Sucursales/List`);
            setGlobalVariable(responseSucursal);
        }

        getTimbresEmpresa();
        getSucursales();
        getLogo(1);

        const storedNotif = parseInt(getDataSession("notificaciones"), 10);
        setNotificaciones(isNaN(storedNotif) ? 0 : storedNotif);
    }, [setGlobalVariable, totalxPagina]);

    function salir() {
        Swal.fire({
            text: 'Esta apunto de salir del panel',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Salir',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                removeUserSession();
                push('..');
            }
        });
    }

    function onSettingsClick(slug) {
        push(slug);
    }

    // Validación segura de enteros positivos para los badges
    const numNotificaciones = parseInt(notificaciones, 10);
    const showNotificaciones = !isNaN(numNotificaciones) && numNotificaciones > 0;

    const numCarrito = parseInt(getDataSession('carrito'), 10);
    const showCarrito = !isNaN(numCarrito) && numCarrito > 0;

    return (
        <>
            <div key="header00" className={`topbar ${classes.headerWrapper}`}>
                <div key="header01" className={classes.titleContainer}>
                    <TituloPagina
                        titulo={globalTitulo?.titulo}
                        descripcion={globalTitulo?.subtitulo}
                    />
                </div>

                <div className={classes.actionsContainer}>
                    <div className={classes.iconStyles}>
                        <LanguageSelector />
                    </div>

                    <div className={classes.iconStyles}>
                        <a href="https://microzync.com/documentacion/" target="_blank" rel="noreferrer">
                            <img src={Ayuda} style={{ width: '24px' }} alt="ayuda" />
                        </a>
                    </div>

                    <div className={classes.iconStyles}>
                        <Link to={SLUGS.mensajes}>
                            <img className='icon-topbar' src={campana} alt="campana" />
                        </Link>
                        {showNotificaciones && (
                            <span className={classes.badgeStyle}>{numNotificaciones}</span>
                        )}
                    </div>

                    <div className={classes.iconStyles}>
                        <Link to={SLUGS.carrito}>
                            <img className='icon-topbar' src={carrito} alt="carrito" />
                        </Link>
                        {showCarrito && (
                            <span className={classes.badgeStyle}>{numCarrito}</span>
                        )}
                    </div>

                    <DropdownComponent
                        label={
                            <div
                                className='menu-user'
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 10,
                                    marginLeft: 15
                                }}
                            >
                                <img className={`avatar-user menu-user ${classes.avatar}`} src={getImagenPerfil() || avatar} alt="avatar" />
                                <div className={`menu-user ${classes.userInfoDesktop}`}>
                                    <span className='username menu-user'>{getNombre()}</span>
                                    <span className='user-rol menu-user'>{getDataSession('rol')}</span>
                                </div>
                            </div>
                        }
                        options={[
                            {
                                label: 'Mi Perfil',
                                style: 'z-index: 10',
                                rol: 'ADMINISTRADOR,EMPRESA,SUCURSAL',
                                onClick: () => onSettingsClick(SLUGS.miperfil)
                            },
                            {
                                label: 'Configuración General',
                                style: 'z-index: 10',
                                rol: 'EMPRESA',
                                onClick: () => onSettingsClick(SLUGS.empresa)
                            },
                            {
                                label: 'Configuración Eshop',
                                style: 'z-index: 10',
                                rol: 'EMPRESA',
                                onClick: () => onSettingsClick(SLUGS.EshopConfig)
                            },
                            {
                                label: 'Lista de usuarios',
                                style: 'z-index: 10',
                                rol: 'ADMINISTRADOR,EMPRESA',
                                onClick: () => onSettingsClick(SLUGS.usuarios)
                            },
                            {
                                label: 'Series de documentos',
                                style: 'z-index: 10',
                                rol: 'EMPRESA',
                                onClick: () => onSettingsClick(SLUGS.seriesEmpresa)
                            },
                            {
                                label: 'Salir',
                                rol: 'ADMINISTRADOR,EMPRESA,SUCURSAL',
                                onClick: () => salir()
                            }
                        ]}
                    />
                </div>
            </div>

            <Notificacion path={location.pathname} />
        </>
    );
}

HeaderComponent.propTypes = {
    title: string
};

export default HeaderComponent;